import { defineMessages } from 'react-intl';

export const i18n: {
	appTooltipFor1Pand3PApps: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	tooltipForAllApps: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	additionalProducts: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	appTooltipFor1Pand3PApps: {
		id: 'inline-app-selector.1p-3p-app-tooltip',
		defaultMessage: 'Open a full page search for this term filtered by {productName} results',
		description:
			'Tooltip shown on a first-party or third-party app button in the inline app selector within the search dialog. The placeholder {productName} will be substituted with the name of the app (e.g. "Jira" or "Confluence").',
	},
	tooltipForAllApps: {
		id: 'inline-app-selector.all-apps-tooltip',
		defaultMessage: 'Open a full page search for this term searching all apps',
		description:
			'Tooltip shown on the "All Apps" button in the inline app selector within the search dialog, indicating that clicking it opens a full-page search across all connected apps.',
	},
	additionalProducts: {
		id: 'inline-app-selector.additional-products',
		defaultMessage: '+ {count}',
		description:
			'Label showing the number of additional product apps available beyond those displayed, e.g. "+ 3"',
	},
});
